import Section from "~/components/Section";
import Page from "~/components/Page";
import Error from "~/components/error/Error";
import Container from "~/components/Container";
import Card from "~/components/ui/Card";

export default function ErrorPage(props: { err: any, reset: () => void }) {

    return (
        <Page>
            <Section>
                <Container>
                    <Card>
                        <Error {...props}></Error>
                    </Card>
                </Container>
            </Section>
        </Page>

    )
}